import * as yup from 'yup';
import * as Schema from '../schemaFields';

export const registerPlayerValidationSchema = yup.object({
  login: Schema.login,
  newPassword: Schema.password,
  confirmationPassword: Schema.repeatPassword,
});
